import Redispatcher from '../../services/redispatcher';

export default redispatcher => () => next => action => {
  if (Redispatcher.events[action.type]) {
    redispatcher && redispatcher.emit(action.type, action.payload);
  }
  return next(action);
};
